import { Formik, FormikHelpers } from "formik";
import {
  ControlcenterMelcoControlCenterModelsForwardLinkListItem,
  useFormSubmit,
  useUserToken,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import * as Yup from "yup";
import { DisplayEditForwardForm } from "./DisplayEditForwardForm";
import { useEditForward } from "../../../hooks/urlforward/useEditForward";

export type SubmitAction = "edit";

export type EditForwardFormValueInterface = {
  id: string | null;
  key: string;
  target: string;
};

type EditForwardFormProps = {
  referenceDrawer: DrawerType;
  onCloseDrawer: (closeDrawer: boolean) => void;
  ForwardLinkDetails: ControlcenterMelcoControlCenterModelsForwardLinkListItem;
};

export const EditForwardForm: React.FC<EditForwardFormProps> = ({
  referenceDrawer,
  onCloseDrawer,
  ForwardLinkDetails,
}) => {
  const { t } = useTranslation();
  const token = useUserToken();
  const editForwardlink = useEditForward();

  const onSubmit = async (
    values: EditForwardFormValueInterface,
    formikHelpers: FormikHelpers<EditForwardFormValueInterface>
  ) => {
    console.log(values);
    if (
      values.key != undefined &&
      values.key != null &&
      values.key != "" &&
      values.target != undefined &&
      values.target != null &&
      values.target != ""
    ) {
    }
    await onAddNewForward(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const initialValues: EditForwardFormValueInterface = {
    id: ForwardLinkDetails.id ? ForwardLinkDetails.id : "",
    key: ForwardLinkDetails.key ? ForwardLinkDetails.key : "",
    target: ForwardLinkDetails.target_url ? ForwardLinkDetails.target_url : "",
  };

  const handleEditForward = async (
    values: EditForwardFormValueInterface,
    formikHelpers: FormikHelpers<EditForwardFormValueInterface>,
    options: {}
  ) => {
    const response = await editForwardlink({ ...values });
    if (response?.success) {
      formikHelpers.resetForm();
      onCloseDrawer(false);
    }
  };

  const formSubmitToAddNewForward = () => {
    return [
      async (
        values: EditForwardFormValueInterface,
        formikHelpers: FormikHelpers<EditForwardFormValueInterface>
      ) => {
        return handleEditForward(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: ["url_forward.actions", "add_new"].join("."),
        onError: () => {
          // refetch entity from server
          //  queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onAddNewForward = useFormSubmit(...formSubmitToAddNewForward());

  const EditForwardSchema = Yup.object().shape({
    key: Yup.string().required(),
    target: Yup.string().required(),
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={EditForwardSchema}
      >
        <DirtyFormPrompt>
          <DisplayEditForwardForm
            ForwardLinkDetails={ForwardLinkDetails}
          ></DisplayEditForwardForm>
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
